import { render } from "./InnerLayoutWithSidebar.vue?vue&type=template&id=6771f0a4&scoped=true"
import script from "./InnerLayoutWithSidebar.vue?vue&type=script&lang=ts"
export * from "./InnerLayoutWithSidebar.vue?vue&type=script&lang=ts"

import "./InnerLayoutWithSidebar.vue?vue&type=style&index=0&id=6771f0a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6771f0a4"

export default script